import _ from "lodash";
import { ajax, ll } from "../../../framework";
import K_ListBox from "../templates/K_ListBox";
import { ComponentOptions } from "./component";
import { InputOptions } from "./input";
import { TemplateComponent } from "./templateComponent";

export interface ListBoxOptions extends InputOptions, kendo.ui.ListBoxOptions {
    id: string;
    selectedId?: string;
    notSelectedId?: string;
    dataTextField?: string;
    baseEntityType?: string;
    baseEntityFilter?: string;
    baseEntitySortField?: string;
    selectedObservableArray?: kendo.data.ObservableArray;
    notSelectedObservableArray?: kendo.data.ObservableArray;
    // tslint:disable-next-line:ban-types
    selectedTemplate?: string|Function;
    // tslint:disable-next-line:ban-types
    notSelectedTemplate?: string|Function;
    selectedPropertyPrefix?: string;
    selectedLabel?: string;
    notSelectedLabel?: string;
    searchEnabled?: boolean;
    notSelectedSearchFields?: string[];
    selectedSearchFields?: string[];
    usingLocalData?: boolean;
}

export class ListBox extends TemplateComponent {

    options: ListBoxOptions;
    selectedListBox: kendo.ui.ListBox;
    notSelectedListBox: kendo.ui.ListBox;
    fullList: any[];
    selectedList: any[];
    notSelectedList: any[];

    constructor(options: ListBoxOptions) {
        super(K_ListBox, options);
    }

    preRender() {
        this.options.screenEntityType = this.options.screenEntityType || "";
        this.options.selectedId = this.options.selectedId || `${this.options.id}_SelectedGroup`;
        this.options.notSelectedId = this.options.notSelectedId || `${this.options.id}_NotSelectedGroup`;
        this.options.dataValueField = this.options.dataTextField || "Id";
        this.fullList = [];
        this.selectedList = [];
        this.notSelectedList = [];

        this.options.selectedLabel = ll(this.options.selectedLabel) || "";
        this.options.notSelectedLabel = ll(this.options.notSelectedLabel) || "";
        this.options.connectWith = this.options.connectWith || "selected";
        this.options.selectable = this.options.selectable || "multiple";
        this.options.toolbar = this.options.toolbar || {
            tools: ["transferTo", "transferFrom", "transferAllTo", "transferAllFrom"]
        };
        this.options.searchEnabled = this.options.searchEnabled || false;
        this.options.usingLocalData = this.options.usingLocalData || false;
    }

    create() {
        var me = this;
        $("#" + me.options.id).attr("screenentitytype", me.options.screenEntityType);

        if (me.options.baseEntityType) {
            var url = `${me.options.baseEntityType}?$top=10000`;

            if (me.options.baseEntityFilter) {
                url += `&$filter=${me.options.baseEntityFilter}`;
            }

            if (me.options.baseEntitySortField) {
                url += `&$orderby=${me.options.baseEntitySortField}`;
            }

            ajax({ url: url }).done(function (data){
                me.fullList = data.d.results;
                me.updateListSets();
            });
        }

        me.options.connectWith = me.options.selectedId;
        me.options.dropSources = [me.options.selectedId];
        me.options.template = me.options.notSelectedTemplate;
        me.notSelectedListBox = $("#" + me.options.notSelectedId).kendoListBox(me.options).data("kendoListBox");
        $("#" + me.options.notSelectedId).after(`<div class='z-none-found-message'>${ll("GridNoDataFound")}</div>`);

        me.options.connectWith = me.options.notSelectedId;
        me.options.dropSources = [me.options.notSelectedId];
        me.options.template = me.options.selectedTemplate;
        delete me.options.toolbar;
        me.selectedListBox = $("#" + me.options.selectedId).kendoListBox(me.options).data("kendoListBox");
        $("#" + me.options.selectedId).after(`<div class='z-none-found-message'>${ll("GridNoDataFound")}</div>`);
        if (me.options.searchEnabled) {
            $("#SelectedLabel").after(`<span class='k-list-filter' style='margin-right: 25px'><input type='text' id='SearchNotSelected' class='k-textbox' placeholder='${ll("Search")}'/><span class='k-icon k-i-search'></span></span><span class='k-list-filter'><input type='text' id='SearchSelected' class='k-textbox' placeholder='${ll("Search")}'/><span class='k-icon k-i-search'></span></span>`);
            if (me.options.notSelectedSearchFields) {
                $("#SearchNotSelected").on("input", function () {
                    var searchString = $(this).val();
                    var filter = { logic: "or", filters: [] };
                    me.options.notSelectedSearchFields.forEach(searchField => {
                        filter.filters.push({ field: searchField, operator: "contains", value: searchString });
                    });
                    // filtering clears out the list of selected items, so grab the current selections to reapply to the list box before setting the filter
                    var selectedItems = me.notSelectedListBox.select();
                    me.notSelectedListBox.dataSource.filter(filter);
                    me.retainListBoxSelections(me.notSelectedListBox, selectedItems);
                    // check and see if there are still any selected items at this point. If there are, remove the k-state-disabled class from the transferTo button so the single right arrow button can be clicked.
                    selectedItems = me.notSelectedListBox.select();
                    if (selectedItems?.length > 0) {
                        var transferToButton = me.notSelectedListBox.wrapper.find("[data-command='transferTo']");
                        if (transferToButton) {
                            transferToButton.removeClass("k-state-disabled");
                        }
                    }
                });
            }
            if (me.options.selectedSearchFields) {
                $("#SearchSelected").on("input", function () {
                    var searchString = $(this).val();
                    var filter = { logic: "or", filters: [] };
                    me.options.selectedSearchFields.forEach(searchField => {
                        filter.filters.push({ field: searchField, operator: "contains", value: searchString });
                    });
                    // filtering clears out the list of selected items, so grab the current selections to reapply to the list box before setting the filter
                    var selectedItems = me.selectedListBox.select();
                    me.selectedListBox.dataSource.filter(filter);
                    me.retainListBoxSelections(me.selectedListBox, selectedItems);
                    // check and see if there are still any selected items at this point. If there are, remove the k-state-disabled class from the transferFrom button so the single left arrow button can be clicked.
                    selectedItems = me.selectedListBox.select();
                    if (selectedItems?.length > 0) {
                        // The notSelectedListBox is the list box that the buttons are associated with, so even though this is for the selectedListBox search, the notSelectedListBox is the proper box to reference here.
                        var transferFromButton = me.notSelectedListBox.wrapper.find("[data-command='transferFrom']");
                        if (transferFromButton) {
                            transferFromButton.removeClass("k-state-disabled");
                        }
                    }
                });
            }
        }
    }

    retainListBoxSelections(listBox: kendo.ui.ListBox, selectedItems: JQuery) {
        if (selectedItems?.length > 0) {
            $(selectedItems).each(function (index) {
                let dataItem = listBox.dataItem(selectedItems[index]);
                if (dataItem) {
                    let uid = dataItem.uid;
                    let item = listBox.wrapper.find("[data-uid='"+uid+"']");
                    if (item) {
                        item.addClass("k-state-selected");
                    }
                }
            });
        }
    }

    updateListSets() {
        var me = this;

        if (me.selectedList.length > 0 && me.fullList.length > 0) {
            if (me.options.usingLocalData === true) {
                let property = me.options.selectedPropertyPrefix;
                me.notSelectedList = _.filter(me.fullList, function (o){
                    return !_.find(me.selectedList, selected => selected[property] == o[property]);
                });
            } else {
                let property = me.options.selectedPropertyPrefix ? me.options.selectedPropertyPrefix + "Id" : "Id";
                me.notSelectedList = _.filter(me.fullList, function (o){
                    return !_.find(me.selectedList, selected => selected[property] == o.Id);
                });
            }
        } else if (me.selectedList.length == 0) {
            me.notSelectedList = me.fullList;
        }

        let selectedDataSource = new kendo.data.DataSource({
            data: me.selectedList,
            filter: me.selectedListBox.dataSource.filter(), // this will keep any current filters applied to the new data source
            sort: me.selectedListBox.dataSource.sort() // this will keep any current sorting applied to the new data source
        });
        me.selectedListBox.setDataSource(selectedDataSource);

        if (me.selectedList.length == 0) {
            me.selectedListBox.wrapper.find(".z-none-found-message").show();
        } else {
            me.selectedListBox.wrapper.find(".z-none-found-message").hide();
        }

        let notSelectedDataSource = new kendo.data.DataSource({
            data: me.notSelectedList,
            filter: me.notSelectedListBox.dataSource.filter(), // this will keep any current filters applied to the new data source
            sort: me.notSelectedListBox.dataSource.sort() // this will keep any current sorting applied to the new data source
        });
        me.notSelectedListBox.setDataSource(notSelectedDataSource);

        if (me.notSelectedList.length == 0) {
            me.notSelectedListBox.wrapper.find(".z-none-found-message").show();
        } else {
            me.notSelectedListBox.wrapper.find(".z-none-found-message").hide();
        }

        $(".k-listbox-toolbar").find("a").removeAttr("href");
    }

    setSelectedDataSource(list: any[]) {
        var me = this;
        me.selectedList = list;
        me.updateListSets();
    }
}
